export default "__VITE_ASSET__y9u9J08V__"